import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { topicChartColors } from '../../constants/colors.js';
import TagCloud from 'react-tag-cloud';
import './plaza.scss';

class PlazaCloud extends Component {
  render() {
    const data = this.props.data.map((word, i) => {
      const newWord = { ...word, size: 10 + Math.random() * 50 };
      return newWord;
    });
    return (
      <div className='app-outer'>
        <div className='app-inner'>
          <TagCloud
            className='tag-cloud'
            style={{
              padding: 7,
              fontFamily: 'Boton'
            }}
          >
            {data &&
              data.map((word, i) => (
                <div
                  key={word.text}
                  style={{ fontSize: word.size, color: topicChartColors[i] }}
                >
                  {word.text}
                </div>
              ))}
          </TagCloud>
        </div>
      </div>
    );
  }
}

PlazaCloud.propTypes = {
  data: PropTypes.any
};

export default PlazaCloud;
